Bingo.CollapseWatcher = {};

/**
 * Prepares watching of collapsable items in forms and append it before form submission in order to restore the same state on the backend (see CollapseWatcher class and BootstrapForm class)
 */
Bingo.CollapseWatcher.initForms = function () {
    const elements = $('form[data-send-collapsed-status]:not([data-send-collapsed-status-initialized=true])');
    elements.attr('data-send-collapsed-status-initialized', true);
    elements.each(function () {
        const form = $(this);
        form.find('input[type=submit]').click(() => {
            let expanded = [];
            form.find('[data-toggle=collapse]').each((index, item) => {
                const target = $(item).attr('data-target');
                if ($(target).attr('aria-expanded') === 'true') {
                    expanded.push(target);
                }
            });
            expanded = Bingo.CollapseWatcher.unique(expanded);
            let input = form.find('input[name=_collapsewatcher_expanded]');
            if (input.length === 0) {
                input = $('<input>').attr('type', 'hidden').attr('name', '_collapsewatcher_expanded');
                form.append($(input));
            }
            input.val(expanded.join(';'));
        });
    });
};

Bingo.CollapseWatcher.unique = function (array) {
    return $.grep(array, (el, index) => index === $.inArray(el, array));
};

Bingo.CollapseWatcher.initGlobal = function () {
    const elements = $('[data-save-collapsed-status]:not([data-save-collapsed-status-initialized=true])');
    elements.attr('data-save-collapsed-status-initialized', true);
    elements.each(function () {
        const target = $(this).attr('data-target');
        $(target).on('show.bs.collapse', function () {
            const temp = `#${$(this).attr('id')}`;
            Bingo.CollapseWatcher.changeState((state) => {
                if (state.indexOf(temp) === -1) {
                    state.push(temp);
                }
                return state;
            });
        });
        $(target).on('hide.bs.collapse', function () {
            const temp = `#${$(this).attr('id')}`;
            Bingo.CollapseWatcher.changeState((state) => {
                const pos = state.indexOf(temp);
                if (pos !== -1) {
                    state.pop(pos);
                }
                return state;
            });
        });
    });
};

Bingo.CollapseWatcher.changeState = function (callback) {
    let cookie = Cookies.get('collapse-watcher');
    if (!cookie) {
        Cookies.set('collapse-watcher', '');
        cookie = Cookies.get('collapse-watcher');
    }
    let state;
    if (!cookie || cookie === '') {
        state = [];
    } else {
        state = cookie.split(';');
    }
    state = callback(state);
    if (!state) {
        return;
    }
    Cookies.set('collapse-watcher', state.join(';'));
};
